import history from '__common/modules/history';
import { ActionTypes, LOCATION_CHANGE } from 'actionsConstants';
import { createReducer } from '__common/utils/helpers';

const { location } = history;
// Create a copy of location with state initialized to avoid read-only property error
const locationWithState = {
  ...location,
  state: location.state || {},
  pathname: location.pathname || '/'
};

const error = null;

// type routerState = {
//   action: {

//   },
//   location: any,
// }

export const routerState = {
  action: history.action || 'POP',
  location: locationWithState,
  error,
};

export default {
  router: createReducer(routerState, {
    [LOCATION_CHANGE](state, action) {
      const { payload } = action;
      return {
        ...state,
        location: {
          ...payload.location,
          pathname: payload.location?.pathname || '/',
          state: payload.location?.state || {}
        },
        action: payload.action || 'POP',
        error: null,
      };
    },
    [ActionTypes.SET_APP_ERROR](state, action) {
      return {
        ...state,
        error: {
          stack: action.payload.stack,
          info: action.payload.info,
          isIE: action.payload.isIE,
        },
      };
    },
    [ActionTypes.REMOVE_APP_ERROR](state) {
      return {
        ...state,
        error: null,
      };
    },
  }),
};
